import React, { useState } from 'react';
import {makeStyles} from "@material-ui/core/styles/index";
import {serverRootUrl} from "../../config";
import Responsive from "../Responsive/Responsive";
import clsx from 'clsx';

const useStyles = makeStyles((theme) => {
    return {
        root: {
            boxShadow: 'none',
            overflow: 'visible',
            position: 'absolute',
            top: 0,
            marginLeft: 700,
            width: '100%',
            height: 524,
            overflowY: 'hidden',
            '@media print' : {
                display: 'none'
            }
        },
        sharing: {
            border: '1px dashed #ccc',
            paddingTop: 5,
            paddingBottom: 5,
            marginLeft: 5,
            marginBottom: 5,
            height: 50,
        },
        inner: {
            border: '1px dashed #ccc',
            padding: '10px 4px 10px 10px',
            marginLeft: 5,
            wheight: 435,
            height: 502,
            overflowY: 'scroll'
        },
        thumbItem: {
            marginRight: 3,
            width: '48%',
            float: 'left',
            position: 'relative',
            maxHeight: 96,
            overflowY: 'hidden',
            '&::after': {
                boxSizing: 'inherit',
                content: '""',
                position: 'absolute',
                borderBottom: '3px solid transparent',
                width: '0',
                height: 2,
                bottom: 3,
                left: 0,
            },
            '&:hover': {
                '&::after': {
                    width: '100%',
                    height: 2,
                    borderBottomColor: '#3849a4',
                    wtransition: 'width 0.15s ease-out, height 0.15s ease-out 0.15s'
                },
            }
        },
        image: {
            cursor: 'pointer',

        },
        disabled: {
            filter: 'grayscale(100%)',
            opacity: .8,
            '& img': {
                cursor: 'default'
            },
            '&::after': {
                borderBottom: 'none',
            },
            '&:hover': {
                '&::after': {
                    width: 0
                }
            }
        }
    }});

export default function Thumbs(props) {

    const classes = useStyles();
    const header = props.header;
    const item = props.item;

    const rootRef = React.useRef();

    const [width, setWidth] = React.useState();

    React.useEffect(() => {
        if (rootRef.current) {
            fixWidth();
        }
    });

    const onResize = () => {
        fixWidth()
    };

    const onClick = (index) => {
        props.onClick(index);
    };

    const onError = (e) => {
        const newSrc = e.target.src.split('_thumb').join('');
        if (newSrc !== e.target.src) {
            e.target.src = newSrc;
        }
    };

    const fixWidth = () => {
        const wrapper = document.getElementById('itemWrapper');
        if (!wrapper) {
            return;
        }
        const newWidth = wrapper.clientWidth - 701;
        if (width !== newWidth) {
            setWidth(newWidth);
        }
    };

    let originalImages = item.images ? item.images.concat() : [];

    let images = item.images.concat();

    if (images.length > 0 && images.length < 10) {
        while (images.length < 10) {
            images.push(images[0]);
        }
    }

    return (
        <div className={classes.root} ref={rootRef} style={{
            width: width
        }}>
            <Responsive onResize={onResize}/>
            {/*<div className={classes.sharing}>

            </div>*/}
            <div className={classes.inner}>
            {width && images && images.map((im, index) => {
                const url = im.image.split('.').join('_thumb.')+'?1';
                return <div className={clsx(classes.thumbItem, index > originalImages.length-1 ? classes.disabled : null)}><img className={classes.image}
                            width="100%"
                            alt={im.description ? im.description : header}
                            src={serverRootUrl + '/' + url}
                            onClick={() => onClick(index > originalImages.length-1 ? 0 : index)}
                            onError={onError}
                /></div>;
            })}
        </div></div>
    );
}
